export default "__VITE_PUBLIC_ASSET__11de4889__"